// v5で書き方が変更 汎用的に使うMUIのコンポーネントスタイルを上書きたい時に記述する
import { PALETTE } from '~/assets/styles/base';

const overrideMUI = {
  MuiButton: {
    styleOverrides: {
      root: {
        '&.MuiButton-size': {
          '&Large': {
            minHeight: '40px',
            minWidth: '280px',
          },
          '&Medium': {
            minHeight: '40px',
          },
          '&Small': {
            minHeight: '32px',
            minWidth: '140px',
            padding: '2px 16px',
          },
        },
        '&.MuiButton-contained': {
          color: PALETTE.white,
          '&.MuiButton-containedSecondary': {
            '&:hover': {
              opacity: '0.8',
            },
            '&:disabled': {
              opacity: '0.48',
            },
          },
        },
        '&.MuiButton-outlined': {
          '&.MuiButton-outlinedSecondary': {
            '&:hover': {
              backgroundColor: '#f6f6f6',
            },
            '&:disabled': {
              opacity: '0.48',
            },
          },
          '&Error': {
            border: `1px solid ${PALETTE.error.main}`,
            color: PALETTE.error.main,
            transition: '0.2s',
            '&:hover': {
              backgroundColor: PALETTE.error.superLight,
            },
          },
        },
      },
    },
  },
};

export default overrideMUI;
